import { useMutation } from '@apollo/client';

import { CancelBankTransferDocument } from './cancelBankTransfer.gql';

const useCancelBankTransfer = (transactionId: string) => {
  return useMutation(CancelBankTransferDocument, {
    variables: {
      input: {
        transactionId,
      },
    },
  });
};

export default useCancelBankTransfer;
